import { Proposal } from "../models"
import { ProposalEmailPayload } from "../services/types"

export const ACTION_TYPES = {
    FETCH : "FETCH_PROPOSAL" as const,
    FETCH_SUCCESS: "FETCH_PROPOSAL_SUCCESS" as const,
    SET: "SET_PROPOSAL" as const,
    SEND_BY_EMAIL: "SEND_BY_EMAIL_PROPOSAL" as const,
}

export type Actions =
    | { type: typeof ACTION_TYPES.FETCH, payload: string }
    | { type: typeof ACTION_TYPES.FETCH_SUCCESS, payload: Proposal }
    | { type: typeof ACTION_TYPES.SET, payload: Proposal }
    | { type: typeof ACTION_TYPES.SEND_BY_EMAIL, payload: Partial<ProposalEmailPayload> }




// WEBPACK FOOTER //
// ./src/state/proposal/actions/types.ts